import React from 'react';
import { Box, Heading, Text, VStack, Image } from '@chakra-ui/react';
import { heartIcon } from '../../assets/figmaAssets';

export default function ValuesSection() {
  return (
    <Box
      as="section"
      aria-label="Nos valeurs fondamentales"
      borderRadius="40px"
      border="1px solid #e5e5e5"
      h={{ base: "345px", md: "477px" }}
      py={{ base: "40px", md: "50px" }}
      px={{ base: "20px", md: "30px" }}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={{ base: "16px", md: "20px" }}>
        {/* Heart Icon */}
        <Image
          src={heartIcon}
          alt="Nos valeurs"
          w="48px"
          h="48px"
        />

        <Heading
          as="h2"
          fontSize={{ base: "28px", md: "45px" }}
          fontWeight="bold"
          fontFamily="Inter, sans-serif"
          color="black"
          textAlign="center"
          letterSpacing="0.1px"
          lineHeight="1.2"
        >
          Nos Valeurs Fondamentales
        </Heading>

        {/* 
          Values list — Figma spec:
          y positions: 235.5, 291.5, 347.5 (56px apart center-to-center)
          fontSize: 30px, lineHeight: 36px → 20px gap between items
        */}
        <VStack spacing={{ base: "14px", md: "20px" }} align="center" pt={{ base: "4px", md: "8px" }}>
          <Text
            fontSize={{ base: "18px", md: "30px" }}
            fontFamily="Inter, sans-serif"
            fontWeight="normal"
            color="black"
            textAlign="center"
            letterSpacing="0.1px"
            lineHeight="1.2"
          >
            Bienveillance et ouverture d'esprit
          </Text>
          <Text
            fontSize={{ base: "18px", md: "30px" }}
            fontFamily="Inter, sans-serif"
            fontWeight="normal"
            color="black"
            textAlign="center"
            letterSpacing="0.1px"
            lineHeight="1.2"
          >
            Absence de compétition
          </Text>
          <Text
            fontSize={{ base: "18px", md: "30px" }}
            fontFamily="Inter, sans-serif"
            fontWeight="normal"
            color="black"
            textAlign="center"
            letterSpacing="0.1px"
            lineHeight="1.2"
          >
            Critiques Constructives
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
}
